module.exports = __webpack_public_path__ + "fonts/ProximaNova-Bold.09394b2.otf";